export default __webpack_public_path__ + "static/media/IconSoundCenter.c580839d.svg";